<p-dialog
    [modal]="true"
    [maximizable]="true"
    [header]="'Atualizar Produto'"
    [(visible)]="modalVisible"
    (onHide)="fecharModal()"
    styleClass="w-125 max-w-[90%]"
>
    <div class="w-full flex flex-col gap-4 p-4">
        @if (typeUpdate === "Grupo") {
            <div class="w-full grid md:grid-cols-2 grid-cols-1 gap-4 items-end">
                <app-input [label]="'Grupo'" [(ngModel)]="grupo"></app-input>

                <!-- <app-select
                    [label]="'Grupo'"
                    [options]="selectGrupo"
                    [(ngModel)]="grupo"
                ></app-select> -->
            </div>

            <div class="w-full flex sm:flex-row flex-col justify-end gap-4">
                <app-button
                    [class]="'w-full md:max-w-45'"
                    (click)="fecharModal()"
                    variant="danger"
                    >Cancelar</app-button
                >

                <app-button
                    [class]="'w-full md:max-w-45'"
                    (click)="updateGrupo()"
                    variant="success"
                    >Confirmar</app-button
                >
            </div>
        }

        @if (typeUpdate === "Marca") {
            <div class="w-full grid md:grid-cols-2 grid-cols-1 gap-4 items-end">
                <app-input [label]="'Marca'" [(ngModel)]="marca"></app-input>

                <!-- <app-select
                    [label]="'Marca'"
                    [options]="selectMarca"
                    [(ngModel)]="marca"
                ></app-select> -->
            </div>

            <div class="w-full flex sm:flex-row flex-col justify-end gap-4">
                <app-button
                    [class]="'w-full md:max-w-45'"
                    (click)="fecharModal()"
                    variant="danger"
                    >Cancelar</app-button
                >

                <app-button
                    [class]="'w-full md:max-w-45'"
                    (click)="updateMarca()"
                    variant="success"
                    >Confirmar</app-button
                >
            </div>
        }

        @if (typeUpdate === "Outros") {
            <app-select
                [label]="'Grupo'"
                [options]="selectGrupo"
                [(ngModel)]="grupo"
            ></app-select>

            <app-select
                [label]="'Marca'"
                [options]="selectMarca"
                [(ngModel)]="marca"
            ></app-select>

            <app-select
                [label]="'SubCategoria'"
                [options]="selectSubCategoria"
                [(ngModel)]="subCategoria"
            ></app-select>

            <app-select
                [label]="'Departamento'"
                [options]="selectDepartamento"
                [(ngModel)]="departamento"
            ></app-select>

            <div class="w-full flex sm:flex-row flex-col justify-end gap-4">
                <app-button
                    [class]="'w-full md:max-w-45'"
                    (click)="fecharModal()"
                    variant="danger"
                    >Cancelar</app-button
                >

                <app-button
                    [class]="'w-full md:max-w-45'"
                    (click)="updateOutros()"
                    variant="success"
                    >Confirmar</app-button
                >
            </div>
        }
    </div>
</p-dialog>
